<script lang="ts">import { fade } from 'svelte/transition';
// import { Portal } from '@squareup/public-web-design-system';
import { ComponentType, DESKTOP_BREAKPOINT_GLOBAL_NAV } from '../../../js-v2/constants';
import { mobileNavStateStore } from '../../../js-v2/stores/mobile-nav-stores';
import { chatWidgetStore } from '../../../js-v2/stores/chat-widget-stores';
import { getTracking } from '../../../js-v2/tracking';
import { getUrlPath } from '../../../js-v2/urlUtils';
import { portal } from '../../../js-v2/portal';
import DesktopNav from './DesktopNav/DesktopNav.svelte';
import MobileNav from './MobileNav/MobileNav.svelte';
import AskSquare from '../../AskSquare/AskSquare.svelte';
const { id = '', homeLink = undefined, primaryNavItems = [], secondaryNavItems = [], enableAskSquare = false, cart = undefined, primaryCtaButton = undefined, secondaryCtaButton = undefined, ctaButtonStyleV1 = false, zIndex = 1000, } = $props();
let innerWidth = $state(undefined);
let chatWidgetContainer = $state();
const trackFn = getTracking();
const desktopMode = $derived(innerWidth === undefined ? null : innerWidth >= DESKTOP_BREAKPOINT_GLOBAL_NAV);
$effect(() => portal(chatWidgetContainer));
// Close mobile nav when switching from mobile to desktop
$effect(() => {
    if (desktopMode && $mobileNavStateStore.isOpen) {
        mobileNavStateStore.toggle();
    }
});
const handleToggleAskSquare = () => {
    trackFn({
        // $chatWidgetStore.isHidden here is the previous state
        eventName: $chatWidgetStore.isHidden ? 'Chatbot Opened' : 'Chatbot Closed',
        properties: {
            currentPage: getUrlPath(),
        },
    });
    chatWidgetStore.toggle();
};
</script>

<svelte:window bind:innerWidth />

<div
  class="GlobalNav"
  data-global-nav-v2
  data-component-type={ComponentType.MAIN_NAVIGATION}
  data-nav-device-type={desktopMode ? 'Desktop' : 'Mobile'}
>
  <DesktopNav
    {id}
    {homeLink}
    {primaryNavItems}
    {secondaryNavItems}
    {enableAskSquare}
    {cart}
    {primaryCtaButton}
    {secondaryCtaButton}
    {ctaButtonStyleV1}
    toggleAskSquare={handleToggleAskSquare}
  />
  <MobileNav
    {id}
    {homeLink}
    {primaryNavItems}
    {secondaryNavItems}
    {enableAskSquare}
    {cart}
    toggleAskSquare={handleToggleAskSquare}
  />
</div>

{#if enableAskSquare}
  <div class="chat-widget-container" bind:this={chatWidgetContainer} style:z-index={zIndex + 1}>
    {#if !$chatWidgetStore.isHidden}
      <div class="chat-widget" transition:fade={{ duration: 250 }} style:z-index={2}>
        <AskSquare onClose={handleToggleAskSquare} isFirstTimeOpen={$chatWidgetStore.isFirstTimeOpen} />
      </div>
      <div class="chat-background-overlay" transition:fade={{ duration: 250 }} style:z-index={1}></div>
    {/if}
  </div>
{/if}

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.chat-widget-container {
  position: fixed;
}

.chat-widget {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: transparent;
  border-radius: 16px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.24);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

@media (max-width: 739px) {
  .chat-widget {
    width: 100dvw;
    height: 100dvh;
    top: 0;
    left: 0;
    transform: none;
    border-radius: 0;
    box-shadow: none;
  }
}
.chat-background-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(242, 242, 242, 0.8);
  backdrop-filter: blur(100px);
}</style>
